import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { LoggingInfo } from '../models/logging-info.model';
import moment from 'moment';
import { LoggingMessageService } from './logging-message.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { SubscriptionChangeService } from './subscription-change.service';


export interface ILoggingApiService {
  debug(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', start: number, path: string, queryString: string, statusCode: number, end: number);
  info(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', start: number, path: string, queryString: string, statusCode: number, end: number);
  warning(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', start: number, path: string, queryString: string, statusCode: number, end: number);
  error(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', start: number, path: string, queryString: string, statusCode: number, end: number);
}

@Injectable({
  providedIn: 'root'
})
export class LoggingApiService implements ILoggingApiService {

  constructor(private logger: LoggingMessageService, private storageService: SessionStorageService, private subscriptionService: SubscriptionChangeService) { }

  public debug(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', start: number, path: string, queryString: string, statusCode?: number, end?: number) {
    const message = this.formatApiMessage(type, method, start, path, queryString, statusCode, end);
    this.logger.debug(appFileName, appMethod, this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  message, '');
  }

  public info(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', start: number, path: string, queryString: string, statusCode?: number, end?: number) {
    const message = this.formatApiMessage(type, method, start, path, queryString, statusCode, end);
    this.logger.info(appFileName, appMethod,this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  message, '');
  }

  public warning(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', start: number, path: string, queryString: string, statusCode?: number, end?: number) {
    const message = this.formatApiMessage(type, method, start, path, queryString, statusCode, end);
    this.logger.warn(appFileName, appMethod, this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  message, '');
  }

  public error(appFileName: string, appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST', start: number, path: string, queryString: string, statusCode?: number, end?: number) {
    const message = this.formatApiMessage(type, method, start, path, queryString, statusCode, end);
    this.logger.error(appFileName, appMethod, this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  message, '');
  }

  private formatApiMessage(type: 'Request' | 'Response', method: 'GET' | 'POST', start: number, path: string, queryString: string, statusCode?: number, end?: number): string {
    const env = environment.production ? 'PROD' : 'DEV';
    const startTime = this.getFormattedDate(start);
    const code = (statusCode === null) ? '' : statusCode;

    let elapsedTime = '';
    let endTime = '';
    if ((end !== null) && (end !== 0)) {
      endTime = this.getFormattedDate(end);
      elapsedTime = this.getElapsedTime(start, end);
    }

    const msg = `Type:${type}, Start:${startTime}, Method:${method}, Path:${path}, Params:${queryString}, End:${endTime}, Status:${code}, Elapsed:${elapsedTime}`;
    return msg;
  }

  private getFormattedDate(numericDate: number): string {
    const nowLocal = moment(numericDate).local();
    const now = nowLocal.format('YYYY-MM-DD HH:mm:ss:SSSS');
    return now;
  }

  private getElapsedTime(start: number, end: number): string {
    const elapsed = end - start;
    return `${elapsed}/ms`;
  }
}
